module.exports = __webpack_public_path__ + "static/media/9x12no1-min.2a8114d1.jpg";